import { createContext, useContext } from "react";

/**
 * Context for managing AI conversation threads
 * Provides functions to reset, load, and manage threads
 */
export interface AiThreadContextValue {
  /** Current active thread ID */
  currentThreadId: string | null;

  /** Reset to start a new thread */
  resetThread: () => void;

  /** Load an existing thread from history */
  loadThread: (threadId: string) => Promise<void>;
}

export const AiThreadContext = createContext<AiThreadContextValue | null>(null);

/**
 * Hook to access AI thread management functions
 */
export function useAiThreadContext() {
  const context = useContext(AiThreadContext);
  if (!context) {
    throw new Error("useAiThreadContext must be used within AiThreadContext.Provider");
  }
  return context;
}
